import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isObject from '@cotyorg/ccx-utils/js/helpers/isObject';
import NavigationLink from '@cotyorg/ccx-molecules/NavigationLink';

const isSelected = (selectedSlug, slug, pages) => (
  selectedSlug === slug || (Array.isArray(pages) && pages.map(page => page.slug).includes(selectedSlug))
);

const generateLinkClassNames = ({
  navigation,
  slug,
  pages,
}) => classNames(
  'navigation__link',
  'navigation__link--hidden-sub-nav',
  'grid-x',
  'align-middle',
  {
    'navigation__link--selected': isSelected(navigation.selectedSlug, slug, pages),
  },
);

const generateNavigationClassNames = ({ extraClass }) => classNames(
  'navigation',
  'navigation--hidden-sub-nav',
  {
    [`${extraClass}`]: extraClass,
  },
);

const NavigationTopLevel = ({
  navigation,
  extraClass,
  NestedListComponent,
  isMobile,
}) => {
  if (!isObject(navigation) || !Array.isArray(navigation.pages)) {
    return null;
  }

  return (
    <nav className={generateNavigationClassNames({ extraClass })}>
      <ul className="navigation__list navigation__list--hidden-sub-nav" data-test="navigation-list">
        {
          navigation.pages.map((page) => {
            const {
              slug,
              name,
              pages,
              url,
              openInNewWindow,
            } = page;

            return (
              <li
                key={slug}
                className="navigation__list-item navigation__list-item--hidden-sub-nav"
                data-test="navigation-list-item"
              >
                <NavigationLink
                  name={name}
                  pages={pages}
                  url={url}
                  openInNewWindow={openInNewWindow}
                  extraClass={generateLinkClassNames({ navigation, slug, pages })}
                  textExtraClass="navigation__link-text navigation__link-text--hidden-sub-nav cell"
                />
                {pages &&
                !!pages.length &&
                <NestedListComponent
                  page={page}
                  selectedSlug={navigation.selectedSlug}
                  isMobile={isMobile}
                />}
              </li>
            );
          })
        }
      </ul>
    </nav>
  );
};

NavigationTopLevel.propTypes = {
  navigation: PropTypes.shape({
    pages: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      pages: PropTypes.array,
      openInNewWindow: PropTypes.bool,
    })),
  }),
  extraClass: PropTypes.string,
  NestedListComponent: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};

export default NavigationTopLevel;
